import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Material UI
import MuiLinearProgress from '@material-ui/core/LinearProgress';
import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiToolbar from '@material-ui/core/Toolbar';
// Core components
import Skeleton from 'components/core/Skeleton';
// Custom
import TablePagination from './TablePagination';

const Table = ({
  head, loading, displayLoading, hasElements, stickyHeader, withFooter, pagination = {}, children,
}) => (
  <React.Fragment>
    {loading && displayLoading && (
      // Note that linear progress zIndex is set to 3 to override sticky header which zIndex is 2
      <div className="table-progress-bar">
        <MuiLinearProgress
          variant="query"
          style={{ zIndex: 3 }}
        />
      </div>
    )}
    <MuiTable stickyHeader={stickyHeader}>
      { head }
      <MuiTableBody>
        { children }
      </MuiTableBody>
    </MuiTable>
    {withFooter && (
      <MuiToolbar>
        {loading ? (
          <Skeleton className="w-100" />
        ) : (
          <React.Fragment>
            {!hasElements && (
              <em><LocalizedMessage id="info.listNoElement" /></em>
            )}
            {pagination && hasElements && (
              <TablePagination {...pagination} />
            )}
          </React.Fragment>
        )}
      </MuiToolbar>
    )}
  </React.Fragment>
);

Table.propTypes = {
  head: PropTypes.node,
  loading: PropTypes.bool,
  displayLoading: PropTypes.bool,
  hasElements: PropTypes.bool,
  stickyHeader: PropTypes.bool,
  withFooter: PropTypes.bool,
  pagination: PropTypes.shape({
    withActions: PropTypes.bool.isRequired,
    currentPage: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    totalEntries: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
  }),
  children: PropTypes.node.isRequired,
};

Table.defaultProps = {
  head: null,
  loading: false,
  displayLoading: false,
  hasElements: false,
  stickyHeader: false,
  withFooter: true,
  pagination: null,
};

export default Table;



// WEBPACK FOOTER //
// ./components/core/table/Table.js